import ProvisionerInfo from "./ProvisionerInfo";

export default ProvisionerInfo;
